"use client"

import { Divider } from "@heroui/divider"

import PrivacyAlert from "@/components/privacy-button"

export default function PageClient() {
  const handleClick = () => {
    window.open("https://snaptheprice.com/rewards", "_blank")
  }
  const handleHelpClick = () => {
    window.open("https://snaptheprice.com/help-center", "_blank")
  }
  return (
    <div className="relative">
      <div className="mb-4 flex-col items-center px-3 pt-4 text-[#1D2129] sm:mb-14 sm:px-[120px] sm:pt-10">
        <div className="text-[24px] font-bold sm:text-[36px]">
          SnapThePrice Cash Out Tutorial
        </div>
        <div className="mb-3 text-[14px] sm:mb-[20px]">
          Follow these steps to redeem your SnapThePrice rewards for cash or
          Amazon Gift Cards.
        </div>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 1: Check Your Available Rewards
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">Log in to your SnapThePrice account.</li>
          <li className="mb-2">
            Go to the{" "}
            <span
              onClick={handleClick}
              className="cursor-pointer text-[#135BFF] underline"
            >
              Rewards Page
            </span>
            .
          </li>
          <li className="mb-2">
            Make sure your Available to Cash Out balance is at least $20.
          </li>
          <li className="mb-3 sm:mb-6">
            ⚠️ Rewards under $20 cannot be redeemed.
          </li>
        </ul>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 2: Bind Your PayPal Account (Optional)
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">On the Rewards Page, click “Link PayPal”.</li>
          <li className="mb-2">Enter your U.S. PayPal account address.</li>
          <li className="mb-2">Confirm the connection.</li>
        </ul>
        <div className="mb-3 text-[14px] sm:mb-6">
          （You can skip this step if you prefer Amazon Gift Card redemption.）
        </div>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 3: Select Your Reward Method
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">
            On the Rewards Page, choose either: <br />
            PayPal → Receive cash directly. <br />
            Amazon Gift Card → Receive equivalent value gift card.
          </li>
          <li className="mb-3 sm:mb-6">
            You can set your preferred method as primary for future cash-outs.
          </li>
        </ul>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 4: Submit Cash Out Request
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">Click the “Request Cash Out” button.</li>
          <li className="mb-2">
            Confirm your selected payout method and amount.
          </li>
          <li className="mb-2">Submit your request.</li>
        </ul>
        <div className="mb-3 text-[14px] sm:mb-6">
          Pending rewards must have completed all eligibility requirements
          (e.g., 10-day activity for new user/install bonuses, referral
          completion).
        </div>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 5: Wait for Verification
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">SnapThePrice team will review your request.</li>
          <li className="mb-2">
            Verification usually takes 3–5 business days.
          </li>
          <li className="mb-3 sm:mb-6">
            Once approved, your reward will be transferred to your PayPal
            account or sent as an Amazon Gift Card.
          </li>
        </ul>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 6: Check Your Payment
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">
            For PayPal: Log in to your account to confirm receipt.
          </li>
          <li className="mb-2">
            For Amazon Gift Card: Check your registered email for the gift card
            code.
          </li>
        </ul>
        <div className="mb-3 text-[14px] sm:mb-6">
          💡 Tip: Rewards never expire. If you don’t reach $20 in one go, your
          balance will roll over until you can redeem.
        </div>
        <div className="mb-1 text-[16px] font-bold sm:mb-2">
          Step 7: Troubleshooting / Support
        </div>
        <ul className="list-disc pl-5 text-[14px] text-[#1D2129]">
          <li className="mb-2">
            If your cash out doesn’t appear within 14 business days:
          </li>
        </ul>
        <ul className="list-disc pl-10 text-[14px] text-[#1D2129]">
          <li className="mb-2">
            Check your{" "}
            <span
              onClick={handleClick}
              className="cursor-pointer text-[#135BFF] underline"
            >
              Rewards Page
            </span>{" "}
            for pending/Payable status.
          </li>
          <li className="mb-2">
            Ensure your PayPal or Amazon account is correct.
          </li>
          <li className="mb-3 sm:mb-6">
            Contact SnapThePrice{" "}
            <span
              onClick={handleHelpClick}
              className="cursor-pointer text-[#135BFF] underline"
            >
              Help Center
            </span>
            ,
          </li>
        </ul>
        <div className="text-[14px] text-[#1D2129]">
          Or Email us at{" "}
          <span className="text-[#135BFF]">support@snaptheprice.com</span>
        </div>
      </div>
      <PrivacyAlert />
    </div>
  )
}
